import { apm } from '@elastic/apm-rum';
import { sleep } from '@sports-utils/timer';
import { waitForOnline } from '@/core/lib/networkStatus';

const DEFAULT_DELAYS_SECONDS = [0, 2, 10, 30];

interface RetryPolicyOptions {
    prefix: string;
    delays?: number[];
}

export function createRetryPolicy({ prefix, delays = DEFAULT_DELAYS_SECONDS }: RetryPolicyOptions) {
    let retryCount = 0;

    function reset() {
        retryCount = 0;
    }

    async function handleError(err: unknown, retry: () => Promise<void>): Promise<void> {
        if (!navigator.onLine) {
            retryCount = 0;
            await waitForOnline();
            await retry();
        } else if (retryCount < delays.length) {
            const delay = delays[retryCount++];
            await sleep(delay);
            await retry();
        } else {
            retryCount = 0;
            const error = err instanceof Error ? err : new Error(String(err));
            error.message = `[${prefix}] ${error.message}`;
            console.error(error);
            apm.captureError(error);
        }
    }

    return { reset, handleError };
}
